/* lua.js generated code 0.3.0 */

var Event = require("cocos/framework/components/event")
FreegiftManager = xClass("FreegiftManager", Event)
FreegiftEvents = table([1, "UpdateMsgNum", "UPDATEMSGNUM"], [1, "UpdateFriendMsgNum", "UPDATEFRIENDMSGNUM"])
var instance = null
FreegiftManager.getInstance = function () {
    var self = this
    if (!instance) {
        instance = FreegiftManager.new()
        instance.init()
    }
    return instance
}
FreegiftManager.prototype.ctor = function () {
    var self = this
    self.bind(self)
    self.availableCount = 0
    self.couponRequested = false
    self.couponList = table()
}
FreegiftManager.prototype.checkShowCoupon = function (onClose) {
    onClose && onClose();
}
FreegiftManager.prototype.init = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    function showCouponPanel() {
        var __VA_ARG = $slice(arguments, 0)
        self.showCoupon = true
    }
    var couponMeta = MetaManager.getInstance().getFriendCouponMeta()
    UserScore.getInstance().on(UserScoreEvent.NewStar, function (event) {
        var levelId = event.levelId
        var oldScore = event.oldScore
        var newScore = event.score
        if (oldScore.star === 0 && newScore.star > 0) {
            for (var k = 1, v = couponMeta[1]; v; k++, v = couponMeta[k]) {
                if (v.type === 1) {
                    if (levelId === v.value) {
                        showCouponPanel()
                        break
                    }
                }
            }
        }
        var oldOrangeStar = UserManager.getInstance().getUserRef().getOrangeStar()
        var oldBlueStar = UserManager.getInstance().getUserRef().getBlueStar()
        var newOrangeStar = oldOrangeStar
        var newBlueStar = oldBlueStar
        var $var18 = oldScore.star + 1,$limit19 = newScore.star
        for (var i = $var18; i <= $limit19; i += 1) {
            if (i === 3) {
                newOrangeStar = oldOrangeStar + 1
            } else if (i === 4) {
                newBlueStar = oldBlueStar + 1
            }
        }
        for (var k = 1, v = couponMeta[1]; v; k++, v = couponMeta[k]) {
            if (v.type === 2) {
                if (newOrangeStar >= v.value && v.value > oldOrangeStar) {
                    showCouponPanel()
                    break
                }
            } else if (v.type === 3) {
                if (newBlueStar >= v.value && v.value > oldBlueStar) {
                    showCouponPanel()
                    break
                }
            }
        }
    })
}
function sortByDate(msgA, msgB) {
    return msgA.receiveDay > msgB.receiveDay
}
//-make sure the messages are of the same type
FreegiftManager.prototype.mergeLikeMsg = function (msgList) {
    var self = this
    if (!msgList || $len(msgList) === 0) {
        return table()
    }
    var couponTable = table()
    for (let index in msgList) {
        let v = msgList[index]
        if(!v){
            continue
        }
        if (!couponTable[v.couponId]) {
            couponTable[v.couponId] = table()
        }
        table.insert(couponTable[v.couponId], v)
    }
    var ret = table()
    for (var couponId in couponTable) {
        var list = couponTable[couponId]
        var combine = table()
        var msg = list[1]
        combine.couponId = msg.couponId
        combine.type = msg.type
        combine.itemId = msg.itemId
        combine.itemNum = msg.itemNum
        combine.id = table()
        combine.senderUid = table()
        for (var k in list) {
            var v = list[k]
            table.insert(combine.id, v.id)
            table.insert(combine.senderUid, v.senderUid)
        }
        table.insert(ret, combine)
    }
    table.sort(ret, function (a, b) {
        return a.couponId > b.couponId
    })
    return ret
}
FreegiftManager.prototype.mergeGiftMsg = function (msgList) {
    var self = this
    if (!msgList || $len(msgList) === 0) {
        return table()
    }
    var itemTable = table()
    for (let index in msgList) {
        let v = msgList[index]
        if(!v){
            continue
        }
        var key = tostring(v.itemId) + "_" + tostring(v.itemNum)
        if (!itemTable[key]) {
            itemTable[key] = table()
        }
        table.insert(itemTable[key], v)
    }
    var ret = table()
    for (var itemKey in itemTable) {
        var list = itemTable[itemKey]
        var msgCount = Math.ceil($len(list) / 5)
        var msg = list[1]
        var $limit45 = msgCount
        for (var i = 1; i <= $limit45; i += 1) {
            var t = table()
            t.couponId = msg.couponId
            t.type = msg.type
            t.itemId = msg.itemId
            t.itemNum = msg.itemNum
            t.id = table()
            t.senderUid = table()
            for (var j = 1; j <= 5; j += 1) {
                var id = (i - 1) * 5 + j
                if (list[id]) {
                    table.insert(t.id, list[id].id)
                    table.insert(t.senderUid, list[id].senderUid)
                }
            }
            table.insert(ret, t)
        }
    }
    table.sort(ret, function (a, b) {
        if (a.itemId === b.itemId) {
            if (a.itemNum === b.itemNum) {
                if (type(a.id) === "table" && type(b.id) === "table") {
                    return $len(a.id) > $len(b.id)
                } else {
                    return a.id < b.id
                }
            } else {
                return a.itemNum > b.itemNum
            }
        } else {
            return a.itemId > b.itemId
        }
    })
    return ret
}
FreegiftManager.prototype.mergeWantMsg = function (msgList) {
    var self = this
    if (!msgList || $len(msgList) <= 0) {
        return table()
    }
    table.sort(msgList, sortByDate)
    var ret = table()
    var msgCount = Math.ceil($len(msgList) / 5)
    var msg = msgList[1]
    var $limit57 = msgCount
    for (var i = 1; i <= $limit57; i += 1) {
        var t = table()
        t.couponId = msg.couponId
        t.type = msg.type
        t.itemId = msg.itemId
        t.itemNum = msg.itemNum
        t.id = table()
        t.senderUid = table()
        for (var j = 1; j <= 5; j += 1) {
            var id = (i - 1) * 5 + j
            if (msgList[id]) {
                table.insert(t.id, msgList[id].id)
                table.insert(t.senderUid, msgList[id].senderUid)
            }
        }
        table.insert(ret, t)
    }
    return ret
}
FreegiftManager.prototype.getSendAvailable = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    return UserManager.getInstance().getLeftFreegift() > 0
}
FreegiftManager.prototype.getReceiveAvailable = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    return UserManager.getInstance().getAcceptGiftLeft() > 0
}
FreegiftManager.prototype.refreshMsgAvailable = function (msgList) {
    var self = this
    var receiveAvaible = UserManager.getInstance().getAcceptGiftLeft() > 0
    var sendAvailable = UserManager.getInstance().getLeftFreegift() > 0
    for (let index in msgList) {
        let v = msgList[index]
        if(!v){
            continue
        }
        if (v.type === 1) {
            v.available = receiveAvaible
        } else if (v.type === 2) {
            v.available = sendAvailable
        } else if (v.type === 3) {
            v.available = true
        } else if (v.type === 4) {
            v.available = true
        }
    }
}
FreegiftManager.prototype.onGiftMsgListSuccess = function (data, callback) {
    let self = this
    var msgList = data.msgList || table()
    var filterMsgList = table()
    for (let index in msgList) {
        let v = msgList[index]
        if (!v) {
            continue
        }
        table.insert(filterMsgList, v)
    }
    self.msgList = filterMsgList
    var likeMsg = table()
    var couponMsg = table()
    var giftMsg = table()
    var wantMsg = table()
    for (var k = 1, v = filterMsgList[1]; v; k++, v = filterMsgList[k]) {
        if (v.type === 1) {
            table.insert(giftMsg, v)
        } else if (v.type === 2) {
            table.insert(wantMsg, v)
        } else if (v.type === 3) {
            table.insert(couponMsg, v)
        } else if (v.type === 4) {
            table.insert(likeMsg, v)
        }
    }
    var ret = table()
    likeMsg = self.mergeLikeMsg(likeMsg)
    for (var _ = 1, v = likeMsg[1]; v; _++, v = likeMsg[_]) {
        v.available = true
        table.insert(ret, v)
    }
    table.sort(couponMsg, function (msgA, msgB) {
        if (msgA.receiveDay === msgB.receiveDay) {
            return msgA.couponId > msgB.couponId
        } else {
            return msgA.receiveDay > msgB.receiveDay
        }
    })
    for (var _ = 1, v = couponMsg[1]; v; _++, v = couponMsg[_]) {
        v.available = true
        table.insert(ret, v)
    }
    var receiveAvaible = UserManager.getInstance().getAcceptGiftLeft() > 0
    giftMsg = self.mergeGiftMsg(giftMsg)
    for (var _ = 1, v = giftMsg[1]; v; _++, v = giftMsg[_]) {
        v.available = receiveAvaible
        table.insert(ret, v)
    }
    var sendAvailable = UserManager.getInstance().getLeftFreegift() > 0
    wantMsg = self.mergeWantMsg(wantMsg)
    for (var _ = 1, v = wantMsg[1]; v; _++, v = wantMsg[_]) {
        v.available = sendAvailable
        table.insert(ret, v)
    }
    self.updateMessageNumber()
    self.messageCount = $len(ret)
    callback(ret)
}

//local MSG_TYPE_ORDER = {[1] = 3, [2] = 4, [3] = 2, [4] = 1}
FreegiftManager.prototype.getGiftMsgList = function (onSuccess, onFail, onCancel) {
    var self = this
    function onFinish(data) {
        self.onGiftMsgListSuccess(data.data, onSuccess)
    }
    function onError(err) {
        onFail(err)
    }
    function onCancelled() {
        var __VA_ARG = $slice(arguments, 0)
        onCancel()
    }
    var http = GetMsgListHttp.new(true)
    http.addEventListener(Events.kComplete, onFinish)
    http.addEventListener(Events.kError, onError)
    http.addEventListener(Events.kCancel, onCancelled)
    http.load(1)
}
FreegiftManager.prototype.getWantFreeGift = function (friendIds, onSuccess, onFail) {
    var self = this
    function onFinish(data) {
        onSuccess(data.data)
    }
    function onError(err) {
        onFail(err)
    }
    function onCancel() {
        var __VA_ARG = $slice(arguments, 0)
    }
    var http = GetWantFreeGiftInfosHttp.new(true)
    http.addEventListener(Events.kComplete, onFinish)
    http.addEventListener(Events.kError, onError)
    http.addEventListener(Events.kCancel, onCancel)
    http.load(friendIds)
}
FreegiftManager.prototype.getCouponList = function (refresh, onSuccess, onFail) {
    var self = this
    if (!refresh && self.couponRequested) {
        onSuccess(self.couponList)
        return 
    }
    function onFinish(data) {
        self.couponRequested = true
        self.couponList = data.data.couponList
        onSuccess(self.couponList)
    }
    function onError(err) {
        onFail(err)
    }
    var http = GetCouponListHttp.new(refresh)
    http.addEventListener(Events.kComplete, onFinish)
    http.addEventListener(Events.kError, onError)
    http.addEventListener(Events.kCancel, onError)
    http.load()
}
FreegiftManager.prototype.getCouponMeta = function (id) {
    var self = this
    var couponMeta = MetaManager.getInstance().getFriendCouponMeta()
    return couponMeta[id]
}
FreegiftManager.prototype.askForGift = function (idList, onSuccess, onFail, onCancel) {
    var self = this
    function onFinish(data) {
        onSuccess(data)
    }
    function onError(error) {
        onFail(error)
    }
    var http = SendMsgHttp.new(true)
    http.addEventListener(Events.kComplete, onFinish)
    http.addEventListener(Events.kError, onError)
    http.addEventListener(Events.kCancel, onCancel)
    http.load(2, idList, 0)
}
FreegiftManager.prototype.sendGift = function (idList, onSuccess, onFail, onCancel) {
    var self = this
    function onFinish(data) {
        onSuccess(data)
    }
    function onError(err) {
        onFail(err)
    }
    var http = SendMsgHttp.new(true)
    http.addEventListener(Events.kComplete, onFinish)
    http.addEventListener(Events.kError, onError)
    http.addEventListener(Events.kCancel, onCancel)
    http.load(1, idList, 0)
}
FreegiftManager.prototype.sendCoupon = function (couponId, onSuccess, onFail, onCancel) {
    var self = this
    function onFinish(data) {
        var failUids = data.data.failUids
        if (!failUids || $len(failUids) > 0) { } else {
            for (var k = 1, v = self.couponList[1]; v; k++, v = self.couponList[k]) {
                if (v.id === couponId) {
                    v.sent = true
                }
            }
        }
        onSuccess(data.data)
    }
    function onError(err) {
        onFail(err)
    }
    var http = SendMsgHttp.new(true)
    http.addEventListener(Events.kComplete, onFinish)
    http.addEventListener(Events.kError, onError)
    http.addEventListener(Events.kCancel, onCancel)
    http.load(3, table(), couponId)
}
FreegiftManager.prototype.getMsgInfo = function (msgId) {
    var self = this
    for (var k = 1, v = self.msgList[1]; v; k++, v = self.msgList[k]) {
        if (v.id === msgId) {
            return [v, k]
        }
    }
    return [null]
}
FreegiftManager.prototype.deleteMsg = function (msgIds, onSuccess, onFail) {
    var self = this
    function onFinish(data) {
        for (var k = 1, v = data.data.succIds[1]; v; k++, v = data.data.succIds[k]) {
            var [msg, index] = self.getMsgInfo(v)
            table.remove(self.msgList, index)
        }
        self.updateMessageNumber()
        onSuccess(data)
    }
    function onError(err) {
        onFail(err)
    }
    var http = ProcessMsgHttp.new(true)
    http.addEventListener(Events.kComplete, onFinish)
    http.addEventListener(Events.kError, onError)
    http.load(msgIds, 2, 1, false)
}
FreegiftManager.prototype.onProcessMsgSuccess = function (msgId) {
    var self = this
    var [msg, index] = self.getMsgInfo(msgId)
    if (!msg) {
        cc.log("Process Message Error : no messge id " + msgId)
        return 
    }
    if (msg.type === 1) {
        UserProp.getInstance().rewardProp(msg.itemId, msg.itemNum, null, null, ModuleName.FRIENDS_FREE_GIFT)
        UserManager.getInstance().incReceiveGiftCount()
    } else if (msg.type === 2) {
        UserManager.getInstance().addPassiveSendId(msg.senderUid)
        var passedLevel = UserManager.getInstance().getPassedTopLevel()
        var giftItem = MetaManager.getInstance().getFreegift(passedLevel)
        if (giftItem && type(giftItem) === "table") {
            DCAssist.dc4FriendGift((tostring(giftItem.itemId) || "0") + ":" + (tostring(giftItem.num) || "0"), 1, "ask")
        }
    } else if (msg.type === 3) {
        UserProp.getInstance().rewardProp(msg.itemId, msg.itemNum, null, null, ModuleName.FRIENDS_FREE_GIFT)
    } else if (msg.type === 4) { }
    table.remove(self.msgList, index)
}
FreegiftManager.prototype.processMsg = function (msgIds, onSuccess, onFail) {
    var self = this
    function onFinish(data) {
        for (var k = 1, v = data.data.succIds[1]; v; k++, v = data.data.succIds[k]) {
            self.onProcessMsgSuccess(v)
        }
        self.updateMessageNumber()
        onSuccess(data.data)
    }
    function onError(err) {
        onFail(err)
    }
    var http = ProcessMsgHttp.new(true)
    http.addEventListener(Events.kComplete, onFinish)
    http.addEventListener(Events.kError, onError)
    http.addEventListener(Events.kCancel, onError)
    http.load(msgIds, 1, 1, false)
}
FreegiftManager.prototype.processAllMsg = function (onSuccess, onFail) {
    var self = this
    function onFinish(data) {
        for (var k = 1, v = data.data.succIds[1]; v; k++, v = data.data.succIds[k]) {
            self.onProcessMsgSuccess(v)
        }
        self.updateMessageNumber()
        onSuccess(data.data)
    }
    function onError(err) {
        onFail(err)
    }
    var http = ProcessMsgHttp.new(true)
    http.addEventListener(Events.kComplete, onFinish)
    http.addEventListener(Events.kError, onError)
    http.addEventListener(Events.kCancel, onError)
    http.load(table(), 1, 1, true)
}
FreegiftManager.prototype.updateMessageNumber = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    var availableCount = 0
    var receiveAvaible = UserManager.getInstance().getAcceptGiftLeft() > 0
    var sendAvailable = UserManager.getInstance().getLeftFreegift() > 0
    for (var k = 1, v = self.msgList[1]; v; k++, v = self.msgList[k]) {
        if (v.type === 1) {
            availableCount = availableCount + (receiveAvaible && 1 || 0)
        } else if (v.type === 2) {
            availableCount = availableCount + (sendAvailable && 1 || 0)
        } else if (v.type === 3) {
            availableCount = availableCount + 1
        } else if (v.type === 4) {
            availableCount = availableCount + 1
        }
    }
    self.availableCount = availableCount
    UserManager.getInstance().setGiftMsgNum(self.availableCount)
    self.dispatchEvent(table([1, "name", FreegiftEvents.UpdateMsgNum], [1, "num", self.availableCount]))
    self.dispatchEvent(table([1, "name", FreegiftEvents.UpdateFriendMsgNum], [1, "num", self.availableCount]))
}
